import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["socialRow"];

  connect() {
    // Don't auto-add - let user add manually
  }

  addSocial() {
    const index = Date.now(); // Use timestamp as unique identifier
    const newRow = document.createElement("div");
    newRow.className = "flex gap-2 items-center";
    newRow.setAttribute("data-social-media-target", "socialRow");
    
    newRow.innerHTML = `
      <input type="text" name="organization[social_media][social_${index}][name]" required placeholder="Platform name (e.g., Facebook)" class="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white" />
      <input type="url" name="organization[social_media][social_${index}][url]" required placeholder="https://..." class="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white" />
      <button type="button" class="px-3 py-2 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/30" data-action="click->social-media#removeSocial">
        Remove
      </button>
    `;
    
    const list = this.element.querySelector("#social-media-list");
    if (list) {
      list.appendChild(newRow);
    } else {
      // Fallback: append to controller element
      this.element.appendChild(newRow);
    }
    
    // Focus on the name input
    const nameInput = newRow.querySelector("input[type=\"text\"]");
    if (nameInput) {
      nameInput.focus();
    }
  }

  removeSocial(event) {
    const row = event.currentTarget.closest("[data-social-media-target='socialRow']");
    if (row) {
      row.remove();
    }
  }
}

